import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Row, Col, Card, CardBody, CardTitle,CardText, Form, Container, Button, Alert, Modal } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import { useHistory } from "react-router-dom"
 import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

import axios from 'axios';
import { HRConfig, TOAST_OPTIONS, formatDate } from "../../helpers/backend_helper"
import * as url from 'helpers/url_helper';

import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Select from 'react-select';

import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'
import { useParams } from 'react-router-dom';

    const RecruitmentRequisitionDetails = () => {
        const history = useHistory();
        const {id} = useParams()
        const [rows1, setrows1] = useState([{ id: 1 }]);
        const [formRows, setFormRows] = useState([{ id: 1 }]);

        const onAddFormRow = () => {
            const modifiedRows = [...formRows];
            modifiedRows.push({ id: modifiedRows.length + 1 });
            setFormRows(modifiedRows);
        };

        const onDeleteFormRow = id => {
            if (id !== 1) {
            var modifiedRows = [...formRows];
            modifiedRows = modifiedRows.filter(x => x["id"] !== id);
            setFormRows(modifiedRows);
            }
        };

        const [inputs, setInputs] = useState([]);
        const [empNo, setEmpNo] = useState('');
        const [empName, setEmpName] = useState('');
        const [empTitle, setEmpTitle] = useState('');

        const [rRNo, setRRNo] = useState('')
        const [rRStatus, setRRStatus] = useState('')

        const [positionOptions, setPositionOptions] = useState([])
        const [positionCode, setPositionCode] = useState("")
        const [expectedStartDate, setExpectedStartDate] = useState("")
        const [numberOfPeople, setNumberOfPeople] = useState("")
        const [location, setLocation] = useState('')

        const [date, setDate] = useState('');
        const [method, setMethod] = useState('');
        const [justification, setJustification] = useState('');
        const [otherRequirements, setOtherRequirements] = useState('');
        const [recruitmentLines, setRecruitmentLines] = useState([])
    
        const [isloading, setIsloading] = useState(false);
        const [userError, setUserError] = useState(true);
        const [ipaSaved, setIpaSaved] = useState(false)
        const [ipaNo, setIpaNo] = useState('')

        const [modal_item, setmodal_item] = useState(false);
        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
          }
          const tog_item = () => {
            setmodal_item(!modal_item);
            removeBodyCss();
          }

        toastr.options = TOAST_OPTIONS;
  
        const handleChange = (event) => {
             const name = event.target.name;
             const value = event.target.value;
             setInputs(values => ({...values, [name]: value}));
        }
        const HandleUpdate = (e) => {
            toastr.success("Requisition Updated" ); 
        }
        const handleCancelApprovalRequest = (e) => {
            setIsloading(true)
            const lNo = {'no': rRNo}
            axios.post(url.RRCANCELAPPROVAL, JSON.stringify(lNo), HRConfig)
                .then(function(response){  
                    if(response.status == '204'){
                        toastr.success("Approval Request Cancelled" ); 
                        history.go(0)
                    }else{
                        toastr.success("Could not Cancel Approval Request" )
                    }
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                })
                .then(function () {
                    setIsloading(false)
                // always executed
            });
        }
        const handleApprovalRequest = (e) => {
            setIsloading(true)
            const lNo = {'no': rRNo}
            axios.post(url.RRAPPROVAL, JSON.stringify(lNo), HRConfig)
                .then(function(response){     

                    if(response.status == '204'){
                        toastr.success("Requisition Sent For Approval" ); 
                        history.go(0)
                    }else{
                        toastr.success("Could not Send for Approval" )
                    }
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                })
                .then(function () {
                    setIsloading(false)
                // always executed
            });
        }
        const handleRR2Project = (e) =>{
            setIsloading(true)
            const lNo = {'no': rRNo}
            axios.post(url.RR2PROJECT, JSON.stringify(lNo), HRConfig)
                .then(function(response){     

                    if(response.status == '204'){
                        toastr.success("Recruitment Project has been created" ); 
                        history.go(0)
                    }else{
                        toastr.success("Could not create recruitment project" )
                    }
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                })
                .then(function () {
                    setIsloading(false)
                // always executed
            });
        }

        useEffect(() => {
            setIsloading(true)
            axios.get(url.RECRUITMENTS1 + "("+ id +")?$expand=recruitmentLines", HRConfig).then((r)=>{
                setIsloading(false)
                setEmpNo(r.data.RequisitionerNo)
                setEmpName(r.data.RequisitionerName)
                setRRNo(r.data.No)
                setRRStatus(r.data.Status)
                setDate(r.data.RequisitionDate)
                setMethod(r.data.RecruitmentMethods)
                setJustification(r.data.Description)
                setLocation(r.data.ShortcutDimension2Code)
                setRecruitmentLines(r.data.recruitmentLines)
                setUserError(false)
                axios.get(url.EMPLOYEES + "?$filter=No eq '"+ r.data.RequisitionerNo +"'", HRConfig)
                       .then(function(response){
                           if(response.data.value.length > 0){
                               setEmpTitle(response.data.value[0].JobTitle);
                               setUserError(false);
                           }else{
                               toastr.error("Employee Details Not Found in Business Central");
                           }
                       }).catch(function (error) {
                           toastr.error(error.response.data.error.message);
                           setUserError(true);
                           console.log(error);
                       })
            }).catch((e)=>{
                setIsloading(false)
                console.log(e)
            })
        },[]);

        
        return (
      
            <LoadingOverlay
                active={isloading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Recruitment Requisition | BRIDGE</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="HRHuman Resource ManagementMIS" breadcrumbItem="Recruitment Requisition" />
                        <div>
                        {userError && ( 
                        <Alert color="danger" role="alert">
                                    Details Not Found in  Business Central
                        </Alert>
                        )}

                        {(ipaSaved == false) ? (
                        <Row>
                        <Col xl={4}>
                        <Card>
                            <CardBody>
                            <CardTitle>Requisitioner Details</CardTitle>
                                    
                                    <Row>
                                    <Col md={12}>
                                        <div className="mb-3">
                                        <label>No</label>
                                        <input type="text" className="form-control EmployeeNo" disabled={true}  value = {empNo} onChange={handleChange}  />
                                        
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                        <label>Name</label>
                                        <input  type="text" className="form-control" disabled={true} defaultValue={empName} onChange={handleChange}   />
                                        
                                        </div>
                                    </Col>
                                                                
                                    <Col md={12}>
                                        <div className="mb-3">
                                        <label>Title</label>
                                        <input  type="text" className="form-control" disabled={true} defaultValue={empTitle} onChange={handleChange} />
                                        
                                        </div>
                                    </Col>
                                </Row>
                                
                                
                                </CardBody>
                            </Card>

                            </Col>
                            <Col  xl={8}>
                            <Card>
                            <CardBody>
                            <CardTitle>Requisition Details</CardTitle>
                                <Row>
                                    <Col md={6}>
                                        <div className="mb-3">
                                        <label>No</label>
                                        <input  type="text" className="form-control" defaultValue={rRNo} disabled={true}   />
                                        
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                        <label>Status</label>
                                        <input  type="text" className="form-control" defaultValue={rRStatus}  disabled={true} />
                                        
                                        </div>
                                    </Col>
                                <Col md={6}>
                                        <div className="mb-3">
                                        <label>Date</label>
                                        <input  type="text" className="form-control" defaultValue={date}  disabled={true} />
                                        
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="mb-3">
                                        <label>Recruitment Method</label>
                                        <input  type="text" className="form-control" defaultValue={method}  disabled={true} />
                                        
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                        <label>Justification for Hire</label>
                                        <input  type="text" className="form-control" defaultValue={justification}  disabled={true}  />
                                        
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                        <label>Location</label>
                                        <input  type="text" className="form-control" defaultValue={location}  disabled={true}  />
                                        
                                        </div>
                                    </Col>
                                   
            
                                   
                                    
                                    </Row>
                                    </CardBody>
                                    </Card>
                                    <div>
                                        {(recruitmentLines || []).map((r, key) => (
                                            
                                      <Card key={key}>
                                        <CardBody>
                                
                                        <CardTitle className="mb-3">
                                        Recruitment Requisition Line {key+1}
                                        </CardTitle>
                                            <Row >
                        
                                            <Col lg={4} className="mb-3">
                                            <div className="mb-3">
                                                <label>Position Code</label>
                                                <input  type="text" className="form-control" defaultValue={r.PositionCode}  />
                                            </div>
                                            </Col>
                                            <Col lg={4} className="mb-3">
                                            <div className="mb-3">
                                            <label>Expected Start Date</label>
                                                <input  type="text" className="form-control" defaultValue={r.ExpectedStartDate}  />
                                                
                                            </div>
                                            </Col>
                                           
                                            <Col lg={4} className="mb-3">
                                            <div className="mb-3">
                                            <label>Number of People</label>
                                                <input  type="text" className="form-control" defaultValue={r.Quantity}  />
                                                
                                            </div>
                                            </Col>
                                           
                                         
                                            </Row>
                                            </CardBody>
                                            </Card>
                                            
                                        ))}
                                        <Row className='justify-content-center'>
                                        {(rRStatus == 'Open') && (
                                        <>
                                        <Col md={4}>
                                            <div className="d-grid gap-2">
                                                <Button color="primary" type="button" className="btn" 
                                                    onClick={HandleUpdate}
                                                    >
                                                    Update Requisition
                                                </Button>
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="d-grid gap-2">
                                                <Button color="warning" type="button" className="btn" 
                                                    onClick={handleApprovalRequest}
                                                    >
                                                   Send Approval Request
                                                </Button>
                                            </div>
                                        </Col>
                                        </>
                                    )}
                                    {(rRStatus == 'Pending Approval') && (
                                        <>
                                        <Col md={4}>
                                            <div className="d-grid gap-2">
                                                <Button color="danger" type="button" className="btn" 
                                                    onClick={handleCancelApprovalRequest}
                                                    >
                                                    Cancel Approval Request
                                                </Button>
                                            </div>
                                        </Col>
                                       
                                        </>
                                    )}
                                    {(rRStatus == 'Approved') && (
                                        <>
                                        <Col md={4}>
                                            <div className="d-grid gap-2">
                                                <Button color="danger" type="button" className="btn" 
                                                    onClick={handleRR2Project}
                                                    >
                                                    Convert to Recruitment Project
                                                </Button>
                                            </div>
                                        </Col>
                                       
                                        </>
                                    )}
                                        </Row>
                                        </div>

                                
                            </Col>
                            <Col>

                                
                               
                                            <br/>
              
                                           
                    
                        </Col>
                        </Row>
                        ):(
                            <Row className="d-flex justify-content-center">
                                <Col lg={8} >
                                <Card outline color="success" className="border">
                                    <CardBody>
                                    <CardTitle className="mb-4 text-white">
                                        
                                    </CardTitle>
                                    <CardText>
                                        
                                    </CardText>
                                    <div className="text-center">
                                        <div className="mb-4">
                                        <i className="mdi mdi-check-circle-outline text-success display-4" />
                                        </div>
                                        <div>
                                        <h5>Saved</h5>
                                        <p className="text-muted">
                                                Recruitment Requisition <strong>{ipaNo}</strong> Saved!
                                        </p>
                                        </div>
                                    </div>
                                    </CardBody>
                                </Card>
                                </Col>
                            </Row>
                        )}
                        </div>


                        
                           

                    </Container>
                </div>
                </LoadingOverlay>

        );
    }

export default RecruitmentRequisitionDetails;